import styled from 'styled-components';
import { ChevronForwardOutlineIc } from '@dsch/dd-icons';

import { InfoTitle } from '../Toolkit/InfoTitle/InfoTitle';
import { Title } from '../Toolkit/InfoTitle/Title/Title';
import { MetaListItem } from '../Toolkit/InfoTitle/MetaListItem/MetaListItem';
import { Link } from '../Toolkit/Button/Link';
import { donedealBreakpoints } from 'styled-system';

export interface ImageCardProps {
  image: string;
  title: string;
  subtext?: string;
  linkText?: string;
  link?: string;
}

const Container = styled.div`
  max-width: 100%;
`;

const CardWrapper = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  overflow: hidden;
  height: 100%;
`;

const ImageContainer = styled.div`
  position: relative;

  img {
    border-radius: ${({ theme }) =>
      `${theme.borderRadius.default} 0 0 ${theme.borderRadius.default}`};
    width: 100%;
    height: auto;
    aspect-ratio: attr(width) / attr(height);
  }
`;

const MainContent = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
`;

const Body = styled.div`
  background: ${({ theme }) => theme.donedeal.colors.WHITE};
  padding: ${({ theme }) => theme.spacing.S8};
  display: flex;
  flex-direction: column;
  align-items: start;

  ${donedealBreakpoints.media.large} {
    padding: ${({ theme }) => theme.spacing.M16};
  }
`;

const SInfoTitle = styled(InfoTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${Title} {
    ${({ theme }) => theme.donedeal.fontSize.B12};
    font-weight: ${({ theme }) => theme.donedeal.fontWeight.bold};

    ${donedealBreakpoints.media.large} {
      ${({ theme }) => theme.donedeal.fontSize.L18};
    }
  }

  ${MetaListItem} {
    ${({ theme }) => theme.donedeal.fontSize.B12};
    font-weight: ${({ theme }) => theme.donedeal.fontWeight.regular};

    ${donedealBreakpoints.media.large} {
      ${({ theme }) => theme.donedeal.fontSize.M14};
    }
  }
`;

const SLink = styled(Link)`
  margin-top: auto;
`;

function ImageCard({ image, title, subtext, linkText, link }: ImageCardProps) {
  return (
    <Container>
      <CardWrapper>
        <ImageContainer>
          <img
            loading="lazy"
            src={image}
            alt={title}
            width="600"
            height="450"
          />
        </ImageContainer>
        <MainContent>
          <Body>
            <SInfoTitle
              title={title}
              listItems={subtext ? [subtext] : []}
              variant="SMALL"
            />
            {linkText && link && (
              <SLink
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                fontSize="M16"
              >
                {linkText}
                <ChevronForwardOutlineIc
                  width="16"
                  height="16"
                  aria-hidden="true"
                />
              </SLink>
            )}
          </Body>
        </MainContent>
      </CardWrapper>
    </Container>
  );
}

export { ImageCard };
